import{createStyles as o}from"../../../../theme/utils/create-styles.js";var r=o({root:{cursor:"move"},rootProjection:{opacity:0}});export{r as styles};
